import { z } from 'zod'
import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationDifferenceLine,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zAreaStyle,
  zBackgroundColor,
  zColor,
  zCrosshairLine,
  zDataset,
  zDimensionLinkage,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zLineStyle,
  zMeasures,
  zPointStyle,
  zRegionPadding,
  zTheme,
  zTooltip,
  zBrush,
  zXBandAxis,
  zYLinearAxis,
  zPage,
  zLineAreaAnimation,
} from '../../properties'

export const zArea = z.object({
  chartType: z.literal('area'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  regionPadding: zRegionPadding.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  animation: zLineAreaAnimation.nullish(),
  xAxis: zXBandAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  crosshairLine: zCrosshairLine.nullish(),
  theme: zTheme.nullish(),
  pointStyle: z.array(zPointStyle).or(zPointStyle).nullish(),
  lineStyle: z.array(zLineStyle).or(zLineStyle).nullish(),
  areaStyle: z.array(zAreaStyle).or(zAreaStyle).nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  annotationDifferenceLine: z.array(zAnnotationDifferenceLine).or(zAnnotationDifferenceLine).nullish(),
  dimensionLinkage: zDimensionLinkage.nullish(),
  locale: zLocale.nullish(),
})
